import React from 'react'

export default function HomeTeam2() {
  return (
 <>
     <section className="team-section team-section2">
      <div className="container">
        <div className="row align-items-center">
          {/* Left Image */}
          <div className="col-md-6">
            <div className="image-section">
              <img  src="/assets/images/strive-img.webp"  className="img-responsive" alt="Sustainability" loading="lazy" />
            </div>
          </div>

          {/* Right Content */}
          <div className="col-md-6">
            <div className="content">
              <h3 className="heading">
                We take responsibility by striving for sustainability
              </h3>
              <p>
                We are committed to operate in a sustainable manner that creates
                value for our customers, employees, investors, communities and
                other stakeholders. Our commitment to sustainability is visible
                at every stage of the value chain. Through a series of actions,
                we aim to achieve the objective: maximizing long-term value
                creation while minimizing environmental impacts and costs.
              </p>
              <p>
                <a href="#">
                  We believe that sustainability is everyone’s job
                </a>{" "}
                and that it is the foundation of good management practice,
                contributing to the long-term success of the company and better
                risk-adjusted returns for customers.
              </p>
              <p>
                Our sustainability focus areas are closely linked to our
                business objectives, and include the following themes:
                workplace, marketplace, environment, and communities, with
                ethical business practices being at the center of our approach.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
 
 
 </>
  )
}


